<template>
  <a
    :href="href"
    :target="target"
    :class="$style.link"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" module>
.link {
  font-weight: 500;
  color: #129cbe;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #097c98;
  }
}
</style>
